import React, { useEffect, useState } from "react";
import { Button, Container, Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import PassFormComponent from "../components/login/PassFormComponent";
import Api from "../services/ApiService";
import IconContentCard from "../components/shared/IconContentCard";
import { BsSignDeadEndFill } from 'react-icons/bs';
import { MdErrorOutline } from 'react-icons/md';

/**
 * PassForgotPage
 * 
 * page for customers to set new password
 * 
 * @url "qr/password/reset/:token"
 * 
 * @components "/compoentns/passForgot"
 * 
 * @returns {redirect} - redirects to HomePage
 */
const PassForgotPage = () => {

    const API = new Api();
    const navigate = useNavigate();
    const { token } = useParams();
    const [tokenIsAlive, setTokenIsAlive] = useState(false);
    const [isLoadingDone, setIsLoadingDone] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        API.password_token_alive(token)
            .then(() => {setTokenIsAlive(true); setIsLoadingDone(true)})
            .catch(() => {setTokenIsAlive(false); setIsLoadingDone(true)});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    return (
        <Container>
            <h1 className="text-center text-energo mt-5 mb-5">Passwort anfordern / zurücksetzen</h1>
            {
                isLoadingDone?
                    tokenIsAlive && error === '' ?
                            <PassFormComponent token={token} error={setError} />
                    :
                    tokenIsAlive === false && error === ''?
                        <IconContentCard icon={<BsSignDeadEndFill size={80}/>} variant="error">
                            <h4 className="text-danger">Link ungültig</h4>
                            <p className="mt-3">
                                Die aufgerufene Adresse existiert nicht oder ist bereits ungültig.
                                Bitte wenden Sie sich an den Support.
                            </p>
                            <div className="text-end mt-5">
                                <Button onClick={() => navigate('/')} className="btn-energo">Zurück zum Login</Button>
                            </div>
                        </IconContentCard>
                    :tokenIsAlive && error !== ''?
                        <IconContentCard icon={<MdErrorOutline size={80}/>} variant="error">
                            <h4 className="text-danger">Fehler aufgetreten</h4>
                            <p className="mt-3">{error}</p>
                            <div className="text-end mt-5">
                                <Button onClick={() => navigate('/')} className="btn-energo">Zurück zum Login</Button>
                            </div>
                        </IconContentCard>
                    :null
                :
                <div>
                    <Spinner animation="glow" className="text-energo" /> &nbsp;
                    <Spinner animation="glow" className="text-energo" /> &nbsp;
                    <Spinner animation="glow" className="text-energo" /> &nbsp;
                </div>
            }
        </Container>
    )
}

export default PassForgotPage;